import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';

export default class TSAdresse extends TSAbstractEntity implements TSSerializable<TSAdresse> {

    private _adresse1: string | undefined;
    private _adresse2: string | undefined;
    private _adresse3: string | undefined;

    private _strasse: string;

    private _hausnummer: string;

    private _zusatzzeile: string;

    private _plz: string;

    private _ort: string;

    private _gemeinde: string;

    private _kanton: string;

    public get adresse1(): string | undefined {
        return this._adresse1;
    }

    public set adresse1(value: string | undefined) {
        this._adresse1 = value;
    }

    public get adresse2(): string | undefined {
        return this._adresse2;
    }

    public set adresse2(value: string | undefined) {
        this._adresse2 = value;
    }

    public get adresse3(): string | undefined {
        return this._adresse3;
    }

    public set adresse3(value: string | undefined) {
        this._adresse3 = value;
    }

    public get strasse(): string {
        return this._strasse;
    }

    public set strasse(value: string) {
        this._strasse = value;
    }

    public get hausnummer(): string {
        return this._hausnummer;
    }

    public set hausnummer(value: string) {
        this._hausnummer = value;
    }

    public get zusatzzeile(): string {
        return this._zusatzzeile;
    }

    public set zusatzzeile(value: string) {
        this._zusatzzeile = value;
    }

    public get plz(): string {
        return this._plz;
    }

    public set plz(value: string) {
        this._plz = value;
    }

    public get ort(): string {
        return this._ort;
    }

    public set ort(value: string) {
        this._ort = value;
    }

    public get gemeinde(): string {
        return this._gemeinde;
    }

    public set gemeinde(value: string) {
        this._gemeinde = value;
    }

    public get kanton(): string {
        return this._kanton;
    }

    public set kanton(value: string) {
        this._kanton = value;
    }

    deserialize(restObject: any): TSAdresse {
        super.deserialize(restObject);
        this.strasse = restObject.strasse;
        this.hausnummer = restObject.hausnummer;
        this.zusatzzeile = restObject.zusatzzeile;
        this.plz = restObject.plz;
        this.ort = restObject.ort;
        this.gemeinde = restObject.gemeinde;
        this.kanton = restObject.kanton;
        this.adresse1 = restObject.adresse1;
        this.adresse2 = restObject.adresse2;
        this.adresse3 = restObject.adresse3;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.strasse = this.strasse;
        restObject.hausnummer = this.hausnummer;
        restObject.zusatzzeile = this.zusatzzeile;
        restObject.plz = this.plz;
        restObject.ort = this.ort;
        restObject.gemeinde = this.gemeinde;
        restObject.kanton = this.kanton;
        restObject.adresse1 = this.adresse1;
        restObject.adresse2 = this.adresse2;
        restObject.adresse3 = this.adresse3;

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSAdresse.ts